import escapeOnErrorCode from './escapeOnErrorCode';

function escapeHtml(text: string): string {
    let resultStr = text;

    resultStr = escapeOnErrorCode(resultStr);

    const entityMap = {
        "<script>": "&lt;script&gt;",
        "</script>": "&lt;/script&gt;",
    };

    for (const key in entityMap) {
        const regex = new RegExp(`${key}`, 'gi');
        resultStr = resultStr.replace(regex, entityMap[key]);
    }

    return resultStr;
}


export default escapeHtml;
